module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.6fc344c0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/theme/fonts/Gotham-Medium.eot
// module id = 875
// module chunks = 40